import HouseType from '../houseType';
import RoomObject from '../room';
export default class Apartment_2_room extends HouseType {
    constructor() {
        super();
        this.id = 'apartment';
        this.name = "2-roms Leilighet";
        this.icon = "mdi-home-city";

        this.defaultRooms = [
            new RoomObject('Entry'),
            new RoomObject('Livingroom'),
            new RoomObject('Kitchen'),
            new RoomObject('Bathroom'),
            new RoomObject('Bedroom')
        ];
    }
}